import { read } from '@/utils/request';
import type { Translation } from '@/typings/i18n';
import i18n from '@/i18n';

import type { CommonModule } from './typings';

const getTimeZone = () => {
  return read<{ key: string; value: string }[]>(
    'user_open/get_time_zone',
    undefined,
    i18n.t('time_zone'),
  );
};

const getTimeZoneSelects = async () => {
  const [res] = await getTimeZone();
  return res?.map(({ key, value }) => ({ value: key, title: value }));
};

const getOeOpenUrl = () =>
  read('user_account/oe_open_url', undefined, i18n.t('failed_to_obtain_Oe_link'));

const mock = '';
// 获取灰度列表
const getFeatureList = () => read<CommonModule.Response.GetFeatureList>(`${mock}wallet/grayscale`);

// 获取翻译数据
const getTranslation = (): Promise<Translation[]> => {
  const url = 'https://league.bluemediagroup.cn/lang?app=vision_line';

  // 文案平台测试环境url，仅限测试使用
  // const url = 'https://bv-dev-nms.domob-inc.cn/lang?app=vision_line&envType=pre';
  return fetch(url)
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        return Promise.reject(res.json());
      }
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};

// 获取汇率
const getRate = () => read<{ rate: number }>('wallet/exchange_rate');

export { getTimeZone, getTimeZoneSelects, getOeOpenUrl, getFeatureList, getTranslation, getRate };
